// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\SmsManualRefillResponse

export type SmsManualRefillApiResponse = {
	refill_requested: boolean;
};

export type SmsManualRefill = {
	refill_requested: boolean;
};

export function hydrateSmsManualRefill(data: SmsManualRefillApiResponse): SmsManualRefill {
	return { ...data };
}